<template>
  <div class="electronic-over-view">
    <!--<el-tabs type="card" v-model="buildingOnPage">-->
    <!--<el-tab-pane v-for="buildItem in buildingList" :label="buildItem.name" :name="buildItem.code" :key="buildItem.code">-->

    <!--</el-tab-pane>-->

    <div class="electronic-over-view-line" style="margin: 40px 0; padding: 0 40px">
      <div class="electronic-person-count-box" style="background: linear-gradient(#1dcbbb, #1dcbbb99)">
        <i class="el-icon-damai-dianbiaolixianshuaibaobiao"></i>
        <div class="electronic-person-count-box-info" style="display: flex; justify-content: space-between; align-items: center">
          <div style="flex: 1">
            <div class="electronic-person-count">{{ gasMeterTotalCount || 0 }}</div>
            <div class="electronic-person-tip">燃气表总数</div>
          </div>
          <div style="flex: 1">
            <div class="electronic-person-count">{{ gasMeterOffCount || 0 }}</div>
            <div class="electronic-person-tip">离线燃气表</div>
          </div>
        </div>
      </div>
      <div class="electronic-person-count-box" style="background: linear-gradient(#12c9e4, #12c9e499)">
        <i class="el-icon-damai-shebei2"></i>
        <div class="electronic-person-count-box-info" style="display: flex; justify-content: space-between; align-items: center">
          <div style="flex: 1">
            <div class="electronic-person-count">{{ gasManagerTotalCount || 0 }}</div>
            <div class="electronic-person-tip">集中器总数</div>
          </div>
          <div style="flex: 1">
            <div class="electronic-person-count">{{ gasManagerOffCount || 0 }}</div>
            <div class="electronic-person-tip">离线集中器</div>
          </div>
        </div>
      </div>
      <div class="electronic-person-count-box" style="background: linear-gradient(#3e78f4, #3e78f499)">
        <i class="el-icon-damai-liuliang"></i>
        <div class="electronic-person-count-box-info">
          <div class="electronic-person-count">{{ gasQuantityTitle || 0 }} <span class="electronic-person-count-unit">立方米</span></div>
          <div class="electronic-person-tip">当月燃气量</div>
        </div>
      </div>
      <div class="electronic-person-count-box" style="background: linear-gradient(#ff9f72, #ff9f7299)">
        <i class="el-icon-damai-yingshoujine"></i>
        <div class="electronic-person-count-box-info">
          <div class="electronic-person-count">{{ gasFeiTitle || 0 }} <span class="electronic-person-count-unit">元</span></div>
          <div class="electronic-person-tip">当月燃气费</div>
        </div>
      </div>
    </div>

    <!--      <div class="electronic-over-view-line" style="margin-bottom: 20px">-->
    <!--        <div class="electronic-over-view-line-left">-->
    <!--          <common-ring commonRingId="ammeterRing" :height="'240px'" :colorList="['#44c23b', '#f54659']" :ringLegend="commonRingLegend" :ringTitle='ammeterTitle' :ringData='ammeterInfo' />-->
    <!--          <common-ring commonRingId="controllerRing" :height="'240px'" :colorList="['#44c23b', '#f54659']" :ringLegend="commonRingLegend" :ringTitle='controllerTitle' :ringData='controllerInfo' />-->
    <!--        </div>-->
    <!--        <div class="electronic-over-view-line-right">-->
    <!--          <div style="width: 50%;padding: 20px 0;">-->
    <!--            <common-ring commonRingId="gasQuantityRing" :height="'240px'" :colorList="commonColorList" :ringLegend="commonRingLegend" :ringTitle='gasQuantityTitle' :ringData='gasQuantityInfo' />-->
    <!--          </div>-->
    <!--          <div style="width: 50%;padding: 20px 0;">-->
    <!--            <common-ring commonRingId="gasFeiRing" :height="'240px'" :colorList="commonColorList" :ringLegend="commonRingLegend" :ringTitle='gasFeiTitle' :ringData='gasFeiInfo' />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="electronic-over-view-line" style="margin-bottom: 20px;border: 1px solid #DCDFE6;box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);position: relative;">-->
    <!--        <div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">-->
    <!--          <el-switch-->
    <!--            v-model="gasityRadio"-->
    <!--            active-text="年度"-->
    <!--            inactive-text="月度">-->
    <!--          </el-switch>-->
    <!--        </div>-->
    <!--        <common-line style="z-index: 1000" lineId='gasityLine' :height='"280px"' :lineTitle='gasityTitle' :legendData="gasityLegendData" :xAxis="gasityXAxis" :yAxis='gasityYAxis' :series='gasitySeries' />-->
    <!--      </div>-->

    <div class="electronic-over-view-line" style="margin-bottom: 20px; border: 1px solid #dcdfe6; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04); padding: 10px 10px; position: relative">
      <chart-time-select @getData="getGasLevleStatistics" />
      <common-line style="z-index: 1000" lineId="gasLevelLine" :height="'280px'" :lineTitle="gasLevelTitle" :legendData="gasLevelLegendData" :xAxis="gasLevelXAxis" :yAxis="gasLevelYAxis" :series="gasLevelSeries" />
    </div>

    <div class="electronic-over-view-line" style="margin-bottom: 20px; border: 1px solid #dcdfe6; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04); padding: 10px 10px; position: relative">
      <chart-time-select @getData="getGasStatistics" />
      <common-line style="z-index: 1000" lineId="gasLine" :height="'280px'" :lineTitle="gasTitle" :legendData="gasLegendData" :xAxis="gasXAxis" :yAxis="gasYAxis" :series="gasSeries" />
    </div>

    <div class="electronic-over-view-line" style="margin-bottom: 20px; border: 1px solid #dcdfe6; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04); position: relative">
      <chart-time-select @getData="getGasRechargeStatistics" />
      <common-line style="z-index: 1000" lineId="gasityLine" :height="'280px'" :lineTitle="gasRechargeStatisticsTitle" :legendData="gasRechargeStatisticsLegendData" :xAxis="gasRechargeStatisticsXAxis" :yAxis="gasRechargeStatisticsYAxis" :series="gasRechargeStatisticsSeries" />
    </div>

    <!--<div class="electronic-over-view-line" style="margin-bottom: 20px; border: 1px solid #eeeeee;border-radius: 10px;padding: 10px 10px;position: relative;">-->
    <!--<div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">-->
    <!--<el-switch-->
    <!--v-model="gasityFeiLineRadio"-->
    <!--active-text="年度"-->
    <!--inactive-text="月度">-->
    <!--</el-switch>-->
    <!--</div>-->
    <!--<common-line style="z-index: 1000" lineId='gasityFeiLine' :height='"280px"' :lineTitle='gasityFeiLineTitle' :legendData="gasityFeiLineLegendData" :xAxis="gasityFeiLineXAxis" :yAxis='gasityFeiLineYAxis' :series='gasityFeiLineSeries' />-->
    <!--</div>-->

    <!--<div class="visitor-over-view-line" style="height: 300px;margin: 30px 0 20px 0;padding: 10px;position: relative;border: 1px solid #eeeeee;border-radius: 10px;">-->
    <!--<div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">-->
    <!--<el-switch-->
    <!--v-model="gasityPayRadio"-->
    <!--active-text="年度"-->
    <!--inactive-text="月度">-->
    <!--</el-switch>-->
    <!--</div>-->
    <!--<common-line style="z-index: 1000" lineId='gasityPayLine' :height='"280px"' :lineTitle='gasityPayTitle' :legendData="gasityPayLegendData" :xAxis="gasityPayXAxis" :yAxis='gasityPayYAxis' :series='gasityPaySeries' />-->
    <!--</div>-->

    <!--<div class="electronic-over-view-line">-->
    <!--<div class="electronic-over-view-line-left" style="justify-content: flex-start;flex-direction: column;height: 270px;display: block">-->
    <!--<div style="display: flex;justify-content: space-between">-->
    <!--<div>欠费住户 ({{arrearsTotal}})</div>-->
    <!--<el-pagination-->
    <!--@current-change="arrearsCurrentChange"-->
    <!--:page-size="arrearsPageSize"-->
    <!--layout="prev, pager, next"-->
    <!--:total="arrearsTotal">-->
    <!--</el-pagination>-->
    <!--</div>-->
    <!--<el-table-->
    <!--:data="arrearsTableData"-->
    <!--style="width: 100%">-->
    <!--<el-table-column-->
    <!--label="住户名称">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="房间号">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.roomName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="余额(元)">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentBalance }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="联系人"-->
    <!--width="180">-->
    <!--<template slot-scope="scope">-->
    <!--<el-popover trigger="hover" placement="top">-->
    <!--<p v-if="scope.row.contractName" style="min-width: 180px;">{{ scope.row.contractName }} / {{ scope.row.contractPhone }} </p>-->
    <!--<p v-else>暂无联系人</p>-->
    <!--<div slot="reference" class="name-wrapper">-->
    <!--<span style="color: #00a0e6">联系人</span>-->
    <!--&lt;!&ndash;<el-tag size="medium">{{ scope.row.name }}</el-tag>&ndash;&gt;-->
    <!--</div>-->
    <!--</el-popover>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--</el-table>-->
    <!--</div>-->
    <!--<div class="electronic-over-view-line-right" style="justify-content: flex-start;flex-direction: column;height: 270px">-->
    <!--<div style="display: flex;justify-content: space-between">-->
    <!--<div>余额不足住户 ({{approachingPaymentTotal}})</div>-->
    <!--<el-pagination-->
    <!--@current-change="approachingPaymentCurrentChange"-->
    <!--:page-size="approachingPaymentPageSize"-->
    <!--layout="prev, pager, next"-->
    <!--:total="approachingPaymentTotal">-->
    <!--</el-pagination>-->
    <!--</div>-->
    <!--<el-table-->
    <!--:data="approachingPaymentTableData"-->
    <!--style="width: 100%">-->
    <!--<el-table-column-->
    <!--label="住户名称">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="房间号">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.roomName }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="余额(元)">-->
    <!--<template slot-scope="scope">-->
    <!--<span>{{ scope.row.rentBalance }}</span>-->
    <!--</template>-->
    <!--</el-table-column>-->
    <!--<el-table-column-->
    <!--label="联系人"-->
    <!--width="180">-->
    <!--<template slot-scope="scope">-->
    <!--<el-popover trigger="hover" placement="top">-->
    <!--<p v-if="scope.row.contractName" style="min-width: 180px;">{{ scope.row.contractName }} / {{ scope.row.contractPhone }} </p>-->
    <!--<p v-else>暂无联系人</p>-->
    <!--<div slot="reference" class="name-wrapper">-->
    <!--<span style="color: #00a0e6">联系人</span>-->
    <!--&lt;!&ndash;<el-tag size="medium">{{ scope.row.name }}</el-tag>&ndash;&gt;-->
    <!--</div>-->
    <!--</el-popover>-->
    <!--</template>-->
    <!--</el-table-column>-->

    <!--</el-table>-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
import { api } from '../../api/GasManagement'
import { errorHandler } from '../../../utils/errorHandler'
import ControllerPie from '../../../components/Echarts/Pie/Pie/controllerPie'
import AmmeterPie from '../../../components/Echarts/Pie/Pie/ammeterPie'
import ElectronicStackingBar from '../../../components/Echarts/Bar/StackingBar/ElectronicStackingBar'
import ElectronicMonthStackingBar from '../../../components/Echarts/Bar/StackingBar/ElectronicMonthStackingBar'
import CommonLine from '../../../components/Echarts/Line/commonLine'
import CommonRing from '../../../components/Echarts/Pie/Pie/commonRing'
import ChartTimeSelect from '../../../components/Echarts/ChartTimeSelect/ChartTimeSelect'

export default {
  components: {
    ChartTimeSelect,
    CommonRing,
    CommonLine,
    ElectronicMonthStackingBar,
    ElectronicStackingBar,
    AmmeterPie,
    ControllerPie,
  },
  name: 'over-view',
  data() {
    return {
      gasSceneList: [],
      // 楼栋
      buildingOnPage: '',
      buildingList: [],

      gasLevelTitle: '级别燃气量统计',
      gasLevelLegendData: [],
      gasLevelXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      gasLevelYAxis: [
        {
          type: 'value',
          name: '燃气量(立方米)',
          splitLine: {
            show: false,
          },
        },
      ],
      gasLevelSeries: [
        {
          name: '',
          type: 'line',
          stack: '统计',
          // areaStyle: {},
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          sampling: 'average',
          itemStyle: {
            color: '#00A0E6',
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#00A0E6',
              },
              {
                offset: 1,
                color: '#ffe',
              },
            ]),
          },
          data: [],
        },
      ],

      gasRadio: false,
      gasTitle: '场景燃气量统计',
      gasLegendData: [],
      gasXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      gasYAxis: [
        {
          type: 'value',
          name: '燃气量(立方米)',
          splitLine: {
            show: false,
          },
        },
      ],
      gasSeries: [
        {
          name: '',
          type: 'line',
          stack: '统计',
          // areaStyle: {},
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          sampling: 'average',
          itemStyle: {
            color: '#00A0E6',
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#00A0E6',
              },
              {
                offset: 1,
                color: '#ffe',
              },
            ]),
          },
          data: [],
        },
      ],

      commonColorList: ['#5B9BD5', '#ED7D31', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC'],
      commonRingLegend: {
        left: 'center',
        bottom: -5,
      },
      ammeterTitle: '燃气表',
      ammeterInfo: [],
      controllerTitle: '控制器',
      controllerInfo: [],
      gasQuantityTitle: '',
      gasQuantityInfo: [],
      gasFeiTitle: '',
      gasFeiInfo: [],

      // 欠费住户
      arrearsPageNum: 1,
      arrearsPageSize: 5,
      arrearsTotal: 0,
      arrearsTableData: [],

      // 临近缴费住户
      approachingPaymentPageNum: 1,
      approachingPaymentPageSize: 5,
      approachingPaymentTotal: 0,
      approachingPaymentTableData: [],

      gasityRadio: false,
      gasityTitle: '燃气量统计',
      gasityLegendData: [],
      gasityXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      gasityYAxis: [
        {
          type: 'value',
          name: '燃气量(立方米)',
          splitLine: {
            show: false,
          },
        },
      ],
      gasitySeries: [
        {
          name: '',
          type: 'line',
          stack: '统计',
          // areaStyle: {},
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          sampling: 'average',
          itemStyle: {
            color: '#00A0E6',
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#00A0E6',
              },
              {
                offset: 1,
                color: '#ffe',
              },
            ]),
          },
          data: [],
        },
      ],

      gasRechargeStatisticsTitle: '充值统计',
      gasRechargeStatisticsLegendData: [],
      gasRechargeStatisticsXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      gasRechargeStatisticsYAxis: [
        {
          type: 'value',
          name: '金额(元)',
          splitLine: {
            show: false,
          },
        },
      ],
      gasRechargeStatisticsSeries: [
        {
          name: '',
          type: 'line',
          stack: '统计',
          // areaStyle: {},
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          sampling: 'average',
          itemStyle: {
            color: '#00A0E6',
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#00A0E6',
              },
              {
                offset: 1,
                color: '#ffe',
              },
            ]),
          },
          data: [],
        },
      ],

      gasityFeiLineRadio: false,
      gasityFeiLineTitle: '燃气费统计',
      gasityFeiLineLegendData: [],
      gasityFeiLineXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      gasityFeiLineYAxis: [
        {
          type: 'value',
          name: '金额(元)',
          splitLine: {
            show: false,
          },
        },
      ],
      gasityFeiLineSeries: [
        {
          name: '',
          type: 'line',
          stack: '统计',
          // areaStyle: {},
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          sampling: 'average',
          itemStyle: {
            color: '#00A0E6',
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#00A0E6',
              },
              {
                offset: 1,
                color: '#ffe',
              },
            ]),
          },
          data: [],
        },
      ],

      gasityPayRadio: false,
      gasityPayTitle: '充值统计',
      gasityPayLegendData: [],
      gasityPayXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
      gasityPayYAxis: [
        {
          type: 'value',
          name: '金额(元)',
          splitLine: {
            show: false,
          },
        },
      ],
      gasityPaySeries: [],

      gasMeterTotalCount: 0,
      gasMeterOffCount: 0,

      gasManagerTotalCount: 0,
      gasManagerOffCount: 0,

      gasFeiLineLegendData: [],
      gasFeiLineXAxis: {
        type: 'category',
        name: '日期',
        data: [],
      },
    }
  },
  created() {
    // this.getBuildingList()
    // this.getArrearsList()
    // this.getApproachingPaymentList()
    // this.getRechargeStatistics(1)
    this.getGasityStatistics(1)
    this.getCurrentMonthGasity()
    this.getGasMeterDeviceOverview()
    this.getGasControlDeviceOverview()
    this.getGasSceneList()
  },
  methods: {
    // 获取楼栋列表
    getBuildingList() {
      this.$axios
        .post(api.getBuildingList, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            data.unshift({
              code: '',
              name: '全部',
            })
            this.buildingList = data
          }
        })
        .catch(errorHandler('获取楼栋列表失败'))
    },

    // 燃气表
    getGasMeterDeviceOverview() {
      this.$axios
        .post(api.getGasMeterDeviceOverview, {})
        .then((res) => {
          let data = res.data.data
          let onLine = { value: data.onlineCount || 0, name: '在线' }
          let offLine = { value: data.offlineCount || 0, name: '离线' }
          this.ammeterInfo = [onLine, offLine]
          this.ammeterTitle = `燃气表(${data.totalCount})`

          this.gasMeterTotalCount = data.totalCount
          this.gasMeterOffCount = data.offlineCount
        })
        .catch(errorHandler('获取燃气表数据失败'))
    },

    // 集中器
    getGasControlDeviceOverview() {
      this.$axios
        .post(api.getGasControlDeviceOverview, {})
        .then((res) => {
          let data = res.data.data
          let onLine = { value: data.onlineCount || 0, name: '在线' }
          let offLine = { value: data.offlineCount || 0, name: '离线' }
          this.controllerInfo = [onLine, offLine]
          this.controllerTitle = `控制器(${data.totalCount})`

          this.gasManagerTotalCount = data.totalCount
          this.gasManagerOffCount = data.offlineCount
        })
        .catch(errorHandler('获取集中器数据失败'))
    },

    getGasRechargeStatistics(type, startTime, endTime) {
      this.$axios
        .post(`${api.getGasRechargeStatistics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY',
        })
        .then((res) => {
          let data = res.data.data
          let xData = []
          let seriesData = []
          data.map((v) => {
            seriesData.push(v.gasInvoicingMoney)
            xData.push(v.time)
          })
          this.gasRechargeStatisticsXAxis.data = xData
          this.gasRechargeStatisticsSeries = [
            {
              name: '',
              type: 'line',
              stack: '总量',
              // areaStyle: {},
              smooth: true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#00A0E6',
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#00A0E6',
                  },
                  {
                    offset: 1,
                    color: '#ffe',
                  },
                ]),
              },
              data: seriesData,
            },
          ]
        })
        .catch(errorHandler('获取数据失败'))
    },

    // 欠费
    arrearsCurrentChange(val) {
      this.arrearsPageNum = val
      this.getArrearsList()
    },

    // 获取欠费住户
    getArrearsList() {
      this.$axios
        .post(api.getEnterprisePageByCondition, {
          enterpriseType: '1',
          pageNum: this.arrearsPageNum,
          pageSize: this.arrearsPageSize,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.arrearsTableData = data.list
            this.arrearsTotal = data.total
          }
        })
        .catch(errorHandler('获取欠费住户失败'))
    },

    // 欠费
    approachingPaymentCurrentChange(val) {
      this.approachingPaymentPageNum = val
      this.getApproachingPaymentList()
    },

    // 获取临近缴费住户
    getApproachingPaymentList() {
      this.$axios
        .post(api.getEnterprisePageByCondition, {
          enterpriseType: '2',
          pageNum: this.approachingPaymentPageNum,
          pageSize: this.approachingPaymentPageSize,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.approachingPaymentTableData = data.list
            this.approachingPaymentTotal = data.total
          }
        })
        .catch(errorHandler('获取临近缴费住户失败'))
    },

    getCurrentMonthGasity() {
      this.$axios
        .get(`${api.getCurrentMonthGasity}`, {})
        .then((res) => {
          let details = res.data.data.details
          let gasQuantityInfo = []
          let gasFeiInfo = []
          let allQuantity = 0
          let allMoney = 0
          if (details) {
            details.map((v) => {
              let gasQuantityObj = {
                name: v.gasSceneName,
                value: v.gasSceneData,
              }
              let gasFeiObj = {
                name: v.gasSceneName,
                value: v.gasSceneMoney,
              }
              allQuantity = parseFloat(allQuantity + v.gasSceneData).toFixed(2)
              allMoney = parseFloat(allMoney + v.gasSceneMoney).toFixed(2)
              gasQuantityInfo.push(gasQuantityObj)
              gasFeiInfo.push(gasFeiObj)
            })
          }
          this.gasQuantityInfo = gasQuantityInfo
          this.gasQuantityTitle = `${res.data.data.totalGasity}`
          this.gasFeiInfo = gasFeiInfo
          this.gasFeiTitle = `${res.data.data.totalMoney}`
        })
        .catch(errorHandler('获取数据失败'))
    },

    getRechargeStatistics(type) {
      this.$axios
        .get(`${api.getRechargeStatistics}/${type}`, {})
        .then((res) => {
          let data = res.data.data
          let xData = []
          let seriesData = []
          data.map((v) => {
            seriesData.push(v.money)
            if (type === 1) {
              let dateArr = v.date.split('-')
              let showData = `${dateArr[1]}-${dateArr[2]}`
              xData.push(showData)
            } else {
              xData.push(v.date)
            }
          })
          this.gasityPayXAxis.data = xData
          this.gasityPaySeries = [
            {
              name: '',
              type: 'line',
              stack: '统计',
              // areaStyle: {},
              smooth: true,
              symbol: 'circle',
              symbolSize: 5,
              sampling: 'average',
              itemStyle: {
                color: '#00A0E6',
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#00A0E6',
                  },
                  {
                    offset: 1,
                    color: '#ffe',
                  },
                ]),
              },
              data: seriesData,
            },
          ]
        })
        .catch(errorHandler('获取数据失败'))
    },

    // 燃气量统计
    getGasityStatistics(type, str) {
      let colorList = ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC']
      this.$axios
        .get(`${api.getGasityStatistics}/${type}`, {})
        .then((res) => {
          let data = res.data.data
          let xData = []
          let gasitySeriesData = []
          let gasityFeiLineSeriesData = []
          let gasityNameData = []
          let gasitySeries = []
          let gasityFeiLineSeries = []
          data.map((v, i) => {
            if (v.details) {
              if (i === 0) {
                v.details.map((detail) => {
                  gasityNameData.push(detail.gasSceneName)
                })
              }
              v.details.map((detail, detailIndex) => {
                if (!gasitySeriesData[detailIndex]) {
                  gasitySeriesData[detailIndex] = []
                }
                gasitySeriesData[detailIndex].push(detail.gasSceneData)
                if (!gasityFeiLineSeriesData[detailIndex]) {
                  gasityFeiLineSeriesData[detailIndex] = []
                }
                gasityFeiLineSeriesData[detailIndex].push(detail.gasSceneMoney)
              })
              if (type === 1) {
                let dateArr = v.billTime.split('-')
                let showData = `${dateArr[1]}-${dateArr[2]}`
                xData.push(showData)
              } else {
                xData.push(v.billTime)
              }
            }
          })
          if (data.length > 0) {
            if (data[0].details) {
              for (let k = 0; k < data[0].details.length; k++) {
                gasitySeries[k] = {
                  name: data[0].details[k].gasSceneName,
                  type: 'line',
                  stack: '统计',
                  // areaStyle: {},
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: colorList[k],
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: colorList[k],
                      },
                      {
                        offset: 1,
                        color: '#ffe',
                      },
                    ]),
                  },
                  data: gasitySeriesData[k],
                }
                gasityFeiLineSeries[k] = {
                  name: data[0].details[k].gasSceneName,
                  type: 'line',
                  stack: '统计',
                  // areaStyle: {},
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: colorList[k],
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: colorList[k],
                      },
                      {
                        offset: 1,
                        color: '#ffe',
                      },
                    ]),
                  },
                  data: gasityFeiLineSeriesData[k],
                }
              }
            }
          }

          if (str === 'gasity') {
            this.gasityXAxis.data = xData
            this.gasityLegendData = gasityNameData
            this.gasitySeries = gasitySeries
          } else if (str === 'gasityFeiLine') {
            this.gasityFeiLineXAxis.data = xData
            this.gasityFeiLineLegendData = gasityNameData
            this.gasityFeiLineSeries = gasityFeiLineSeries
          } else {
            this.gasityXAxis.data = xData
            this.gasityFeiLineXAxis.data = xData
            this.gasitySeries = gasitySeries
            this.gasityFeiLineSeries = gasityFeiLineSeries
            this.gasityLegendData = gasityNameData
            this.gasityFeiLineLegendData = gasityNameData
          }
        })
        .catch(errorHandler('获取数据失败'))
    },

    // 级别燃气量统计
    getGasLevleStatistics(type, startTime, endTime) {
      let colorList = ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC']
      this.$axios
        .post(`${api.getGasLevelStatistics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY',
        })
        .then((res) => {
          let data = res.data.data
          let xData = []
          let gasSeriesData = []
          let gasNameData = ['一级', '二级', '三级', '四级', '五级']
          let gasSeries = []

          setTimeout(() => {
            data.map((v, i) => {
              gasNameData.map((gasName, gasNameIndex) => {
                if (!gasSeriesData[gasNameIndex]) {
                  gasSeriesData[gasNameIndex] = []
                }
                if (v.gasDetails) {
                  v.gasDetails.map((detail, detailIndex) => {
                    if (!gasSeriesData[gasNameIndex][i]) {
                      gasSeriesData[gasNameIndex][i] = 0
                    }
                    if (detail.level === gasNameIndex + 1) {
                      gasSeriesData[gasNameIndex][i] = detail.gasCommon
                    }
                  })
                } else {
                  gasSeriesData[gasNameIndex][i] = 0
                }
              })
              xData.push(v.time)
            })
            if (data.length > 0) {
              for (let k = 0; k < gasNameData.length; k++) {
                gasSeries[k] = {
                  name: gasNameData[k],
                  type: 'line',
                  stack: '统计',
                  // areaStyle: {},
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: colorList[k],
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: colorList[k],
                      },
                      {
                        offset: 1,
                        color: '#ffe',
                      },
                    ]),
                  },
                  data: gasSeriesData[k],
                }
              }
            }
            this.gasLevelLegendData = gasNameData
            this.gasLevelXAxis.data = xData
            this.gasLevelSeries = gasSeries
          }, 50)
        })
        .catch(errorHandler('获取数据失败'))
    },

    // 获取场景列表
    getGasSceneList() {
      this.$axios
        .post(api.getGasSceneList, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.gasSceneList = data
          }
        })
        .catch(errorHandler('获取场景列表失败'))
    },

    // 场景燃气量统计
    getGasStatistics(type, startTime, endTime) {
      let colorList = ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5', '#C2A753', '#4BB66E', '#FFA336', '#53A5BC']
      this.$axios
        .post(`${api.getGasStatistics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY',
        })
        .then((res) => {
          let data = res.data.data
          let xData = []
          let gasSeriesData = []
          let gasFeiLineSeriesData = []
          let gasNameData = []
          let gasSeries = []
          let gasFeiLineSeries = []
          this.gasSceneList.map((v) => {
            gasNameData.push(v.name)
          })
          setTimeout(() => {
            data.map((v, i) => {
              gasNameData.map((gasName, gasNameIndex) => {
                if (!gasSeriesData[gasNameIndex]) {
                  gasSeriesData[gasNameIndex] = []
                }
                if (!gasFeiLineSeriesData[gasNameIndex]) {
                  gasFeiLineSeriesData[gasNameIndex] = []
                }
                if (v.details) {
                  v.details.map((detail, detailIndex) => {
                    if (!gasSeriesData[gasNameIndex][i]) {
                      gasSeriesData[gasNameIndex][i] = 0
                      gasFeiLineSeriesData[gasNameIndex][i] = 0
                    }
                    if (detail.gasSceneName === gasName) {
                      console.log(detail)
                      gasSeriesData[gasNameIndex][i] = detail.gasSceneData
                      gasFeiLineSeriesData[gasNameIndex][i] = detail.gasSceneMoney
                    }
                  })
                } else {
                  gasSeriesData[gasNameIndex].push(0)
                  gasFeiLineSeriesData[gasNameIndex].push(0)
                }
              })
              if (type === 1) {
                let dateArr = v.billTime.split('-')
                let showData = `${dateArr[1]}-${dateArr[2]}`
                xData.push(showData)
              } else {
                xData.push(v.billTime)
              }
            })
            if (data.length > 0) {
              for (let k = 0; k < gasNameData.length; k++) {
                gasSeries[k] = {
                  name: gasNameData[k],
                  type: 'line',
                  stack: '统计',
                  // areaStyle: {},
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: colorList[k],
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: colorList[k],
                      },
                      {
                        offset: 1,
                        color: '#ffe',
                      },
                    ]),
                  },
                  data: gasSeriesData[k],
                }
                gasFeiLineSeries[k] = {
                  name: gasNameData[k],
                  type: 'line',
                  stack: gasNameData[k],
                  // areaStyle: {},
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: colorList[k],
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: colorList[k],
                      },
                      {
                        offset: 1,
                        color: '#ffe',
                      },
                    ]),
                  },
                  data: gasFeiLineSeriesData[k],
                }
              }
            }
            setTimeout(() => {
              this.gasXAxis.data = xData
              this.gasFeiLineXAxis.data = xData
              this.gasSeries = gasSeries
              this.gasFeiLineSeries = gasFeiLineSeries
              this.gasLegendData = gasNameData
              this.gasFeiLineLegendData = gasNameData
            }, 50)
          }, 50)
        })
        .catch(errorHandler('获取数据失败'))
    },
  },

  watch: {
    // gasityPayRadio (val) {
    //   if (!val) {
    //     this.getRechargeStatistics(1)
    //   } else {
    //     this.getRechargeStatistics(2)
    //   }
    // },
    // gasityRadio (val) {
    //   if (!val) {
    //     this.getEgasityStatistics(1, 'gasity')
    //   } else {
    //     this.getEgasityStatistics(2, 'gasity')
    //   }
    // },
    // gasityFeiLineRadio (val) {
    //   if (!val) {
    //     this.getEgasityStatistics(1, 'gasityFeiLine')
    //   } else {
    //     this.getEgasityStatistics(2, 'gasityFeiLine')
    //   }
    // }
  },
}
</script>

<style lang="less">
.electronic-over-view {
  padding: 10px 2%;
  .electronic-over-view-line {
    display: flex;
    justify-content: space-between;
    .electronic-person-count-box {
      width: 23%;
      height: 160px;
      padding: 10px 10px;
      border-radius: 10px;
      color: #ffffff;
      background-color: #00a0e6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #dcdfe6;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
      i {
        width: 30%;
        font-size: 48px;
      }
      .electronic-person-count-box-info {
        width: 70%;
        text-align: left;
        .electronic-person-count {
          font-size: 36px;
          font-weight: 600;
          word-wrap: break-word;
          .electronic-person-count-unit {
            font-size: 12px;
          }
        }
        .electronic-person-tip {
          font-size: 16px;
        }
      }
    }
    .electronic-over-view-line-left {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
    }
    .electronic-over-view-line-right {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
    }

    .el-table {
      thead {
        th {
          padding: 6px 0;
          text-align: center;
          color: #666666;
          background-color: #eff1f5;
        }
      }
      tbody {
        td {
          padding: 6px 0;
          text-align: center;
          color: #ff0000;
        }
      }
    }

    .el-pagination {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/GasManage/OverView/OverView.vue